module.exports = __webpack_public_path__ + "img/Settings.74f3da37.svg";